<template>
  <b-container>
    <ProfileHero :artist="artist" :user="profile" v-if="artist || profile" />
    <ArtistProfileTabs :artist="artist" v-if="artist" />
    <FanProfileTabs :user="profile" v-if="profile" />

    <div class="videos">
      <VideoCard :video="video" v-for="video in videos" :key="video.id" :showDate="true" :showArtist="true" />
    </div>
  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .videos {
    margin-top: 1em;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  @include media-breakpoint-up(md) {
    .videos {
      justify-content: left;
    }
  }

</style>

<script>
import ArtistProfileTabs from '@/components/widgets/ArtistProfileTabs'
import FanProfileTabs from '@/components/widgets/FanProfileTabs'
import ProfileHero from '@/components/widgets/ProfileHero'
import VideoCard from '@/components/widgets/VideoCard'

export default {
  name: 'FeaturedVideos',
  components: {
    ArtistProfileTabs,
    FanProfileTabs,
    ProfileHero,
    VideoCard
  },
  data () {
    return {
      artist: null,
      profile: null,
      videos: []
    }
  },
  computed: {
  },
  created () {
    this.initPage()
  },
  watch: {
    '$route': 'initPage'
  },
  methods: {
    async initPage () {
      let handle

      if (this.$route.params.artistId) {
        this.profile = null
        this.artist = await this.$store.dispatch('artist/getArtist', { id: this.$route.params.artistId })
        handle = this.artist.handle
      } else {
        this.artist = null
        this.profile = await this.$store.dispatch('profile/getProfile', { id: this.$route.params.id })
        handle = this.profile.username
      }

      const response = await this.$store.dispatch('song/listSongs', {featured: handle})
      this.videos = await response.all()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/artist/FeaturedVideos.vue